import React, { useEffect, useState } from "react";
import { TextField } from "@mui/material";

const NumberFieldComponent = (props: any) => {
    const [value, setValue] = useState('');
    
    useEffect(() => {
        setValue(props.model[props.field] ?? '');
    }, [props.model]);

    function setModelEvent(value: any) {
        setValue(value);
        props.model[props.field] = value;
    }

    return (
        <div className={props.divClassName}>
            <TextField
                fullWidth
                required={props.required}
                onChange={(e: any) => setModelEvent(e.target.value)} 
                label={props.label}
                value={value}
                variant="outlined"
                inputProps={{ type: 'number'}}
                style={{ marginRight: 10 }} />
        </div>
    )
}

export default NumberFieldComponent